class ProductService extends BaseService
	@register angular.module 'App.Service'
	@inject 'BACKEND_PRODUCT_DATA_ENTITY_TYPE',
		'BACKEND_VAT_RATE_DATA_ENTITY_TYPE'

	getPriceRegion: (priceRegions, productData) ->
		if productData?.length == 1
			return _.findWhere priceRegions, {id: productData[0].price_region_id}

		return priceRegions[0]

	getDefaultProductData: (productData, priceRegion) ->
		getExistingProductData = (productDataArray) =>
			for productData in productDataArray
				if productData.entity_type == @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
					return productData
			return null

		defaultProductData = getExistingProductData(productData)

		# If it does not exists create a new default one
		if !defaultProductData?
			defaultProductData =
				price_region_id: priceRegion.id
				entity_type: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
				vat_rate_id: null
				variable_price: null
				cost_price: 0
				retail_price: 0
				least_quantity: 0
				product_variant_id: null

		defaultProductData.price_region_id = priceRegion.id

		return defaultProductData
